"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var UclPitStop_exports = {};
__export(UclPitStop_exports, {
  UclPitStop: () => UclPitStop
});
module.exports = __toCommonJS(UclPitStop_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const UclPitStop = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("UclPitStop"),
  title: "Project Pit Stop",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("UclPitStop"),
      title: "Project Pit Stop",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("UclPitStop"),
        attribution: []
      }),
      defaultAttribute: "status",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          attributes: [
            (0, import_topo_map.timestampAttr)({
              label: "Date/Time",
              attributeId: "timestamp",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.attachmentAttr)("arrivalPhotographs", "Arrival Photographs"),
            (0, import_topo_map.numberAttr)({
              label: "Pit Stop Pond Number",
              attributeId: "pitStopPondNumber",
              buckets: "auto",
              decimalPlaces: 0
            }),
            (0, import_topo_map.enumAttr)({
              label: "Pond Status",
              attributeId: "status",
              enum: import_inventory_enums.UclPitStopPondStatusEnum,
              markers: {
                Ghost: import_topo_map.marker.fromColor("#FFF"),
                Zombie: import_topo_map.marker.fromColor("#644536"),
                Living: import_topo_map.marker.fromColor("#548C2F"),
                Other: import_topo_map.marker.fromColor("#A020F0")
              }
            }),
            (0, import_topo_map.enumAttr)({
              label: "What is seen on the OS map?",
              attributeId: "point",
              enum: import_inventory_enums.UclPitStopMapPointEnum,
              markers: {
                Water: import_topo_map.marker.fromColor("#4259C3"),
                Vegetation: import_topo_map.marker.fromColor("#548C2F"),
                Other: import_topo_map.marker.fromColor("#777")
              }
            }),
            (0, import_topo_map.numberAttr)({
              label: "Ponds within 1km",
              attributeId: "pondCount",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 1, import_topo_map.marker.fromColor("#9EC2FF"), void 0, true),
                (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.fromColor("#7B9FF2"), "2"),
                (0, import_topo_map.rangeBucket)(3, 4, import_topo_map.marker.fromColor("#4259C3"), "3"),
                (0, import_topo_map.rangeBucket)(4, 5, import_topo_map.marker.fromColor("#212AA5"), "4"),
                (0, import_topo_map.rangeBucket)(5, null, import_topo_map.marker.fromColor("#03018C"))
              ]
            }),
            (0, import_topo_map.enumAttr)({
              label: "Description of Pond",
              attributeId: "description",
              enum: import_inventory_enums.UclPitStopDescriptionEnum,
              markers: {
                Farmland: import_topo_map.marker.fromColor("#644536"),
                NatureReserveOrWoodland: import_topo_map.marker.fromColor("#548C2F")
              }
            }),
            (0, import_topo_map.numberAttr)({
              label: "Water Coverage",
              attributeId: "waterCoverage",
              unit: "%",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 20, import_topo_map.marker.fromColor("#9EC2FF")),
                (0, import_topo_map.rangeBucket)(20, 40, import_topo_map.marker.fromColor("#7B9FF2")),
                (0, import_topo_map.rangeBucket)(40, 60, import_topo_map.marker.fromColor("#4259C3")),
                (0, import_topo_map.rangeBucket)(60, 80, import_topo_map.marker.fromColor("#212AA5")),
                (0, import_topo_map.rangeBucket)(80, null, import_topo_map.marker.fromColor("#03018C"))
              ]
            }),
            (0, import_topo_map.numberAttr)({
              label: "Canopy Cover of Water Surface",
              attributeId: "areaShade",
              unit: "%",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 20, import_topo_map.marker.fromColor("#E6E0D0")),
                (0, import_topo_map.rangeBucket)(20, 40, import_topo_map.marker.fromColor("#B6A691")),
                (0, import_topo_map.rangeBucket)(40, 60, import_topo_map.marker.fromColor("#9F8872")),
                (0, import_topo_map.rangeBucket)(60, 80, import_topo_map.marker.fromColor("#876B52")),
                (0, import_topo_map.rangeBucket)(80, null, import_topo_map.marker.fromColor("#6F4E33"))
              ]
            }),
            (0, import_topo_map.numberAttr)({
              label: "Aquatic Plant Cover",
              attributeId: "aquaticPlantCover",
              unit: "%",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 20, import_topo_map.marker.fromColor("#B7FFBF")),
                (0, import_topo_map.rangeBucket)(20, 40, import_topo_map.marker.fromColor("#95F985")),
                (0, import_topo_map.rangeBucket)(40, 60, import_topo_map.marker.fromColor("#4DED30")),
                (0, import_topo_map.rangeBucket)(60, 80, import_topo_map.marker.fromColor("#26D701")),
                (0, import_topo_map.rangeBucket)(80, null, import_topo_map.marker.fromColor("#00AB08"))
              ]
            }),
            (0, import_topo_map.enumAttr)({
              label: "Norfolk's Most Wanted",
              attributeId: "norfolkMostWanted",
              enum: import_inventory_enums.UclPitStopNorfolkMostWantedEnum
            }),
            (0, import_topo_map.enumAttr)({
              label: "Crassula Helmsii",
              attributeId: "crassula",
              enum: import_inventory_enums.UclPitStopCrassulaHelmsiiEnum,
              markers: {
                None: import_topo_map.marker.fromColor("#FFF"),
                SmallFragments: import_topo_map.marker.fromColor("#777"),
                EasilyVisible: import_topo_map.marker.fromColor("#000")
              }
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Demo Calculations",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              label: "Calculation 1",
              attributeId: "calculation1",
              buckets: [(0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("pink"), "Yes"), (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.empty, "No")]
            }),
            (0, import_topo_map.booleanAttr)({
              label: "Calculation 2",
              attributeId: "calculation2",
              buckets: [(0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("red"), "Yes"), (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.empty, "No")]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UclPitStop
});
//# sourceMappingURL=UclPitStop.js.map
